import HARDCODE from '../../business-const/HardCode/HardCode'



const percentualList = [
    {
        id: 10, 
        descricao: '10%',
        ordem: 10,
    },
    {
        id: 20, 
        descricao: '20%',
        ordem: 20,
    },
    {
        id: 30, 
        descricao: '30%',
        ordem: 30,
    },
    {
        id: 40, 
        descricao: '40%',
        ordem: 40,
    },
    {
        id: 50, 
        descricao: '50%',
        ordem: 50,
    },
    {
        id: 60, 
        descricao: '60%',
        ordem: 60,
    },
    {
        id: 70, 
        descricao: '70%',
        ordem: 70,
    },
    {
        id: 80, 
        descricao: '80%',
        ordem: 80,
    },
    {
        id: 90, 
        descricao: '90%',
        ordem: 90,
    },
    {
        id: HARDCODE.percentual100, 
        descricao: '100%',
        ordem: 100,
    },
]

export default percentualList